import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import { baseLogoImg } from '../../../shared/fontsAndBitImages';
import { baseLogoGlencoImg } from '../../../shared/fontsAndBitImagesGLENCO';
import moment from 'moment';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import lodash from 'lodash';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { blueGrey } from '@material-ui/core/colors';
import axiosRetry from 'axios-retry';
import { buildZatcaLines, readSupplyDate, readOrderReference, issueStandardInvoice, describeZatcaError, SAMPLE_BUYER } from '../../Masters/Zatca/zatcaInvoice';


const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={Object.assign({}, metaData,)}
    /> || null;

}
let disabledDays = ''
let ser ='';

let currencyList = [
    {"label":"Kuwaiti Dinar,KWD - KWD","value":248,"id":"KWD"},
    {"label":"US Dollars,USD - USD","value":2,"id":"USD"},
    {"label":"Euro,EUR - EUR","value":3,"id":"EUR"},
    {"label":"Indian Rupees,INR - INR","value":4,"id":"INR"},
    {"label":"Omani Rials,OMR - OMR","value":5,"id":"OMR"},
    {"label":"Saudi Riyals,SAR - SAR","value":6,"id":"SAR"},
    {"label":"UAE Dirham,AED - AED","value":7,"id":"AED"}]; 

const RECINVOICE_ID = '4548BD63-B15C-4407-B5D5-3E3C33388110';

class AddInvoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            stageSequence: 0,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            error: false,
            popupType: 'submit',
            editing: false,
            TARequestNumber: [],
            requestattachments:[],
            Invoicenumber:'',
        }
        this.initialize = this.initialize.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this);
        this.handleContainer = this.handleContainer.bind(this);
    }


    handleChange = (e, el) => {
        e.preventDefault();
        let priceperunit=0;
        let taxpercentage = 0;
        let texableamount = 0;
        let taxamount = 0;
        let itemsubtotal = 0;
        let baseunit = '';

        //const { name, value } = e.target;
        const { name, value, type, checked } = e.target;  
        const { stageSequence, process, fromDate, toDate } = this.state;



        if(el.fieldDescription === 'Discount'){
            let stages = process.filter((p, i) => i < parseInt(stageSequence) + 1);
            let mystages = process.filter((p, i) => i < parseInt(stageSequence) + 1)
            let myfieldItemSubTotal = mystages[0].stage_Field.filter(er => er.fieldDescription == 'Item Sub Total Including VAT' && er.childRowNmbr == el.childRowNmbr)
            let ItemSubTotal = myfieldItemSubTotal[0].fieldValue ? myfieldItemSubTotal[0].fieldValue : 0; 

            let dis = value ? parseInt(value) : 0;
            dis = ItemSubTotal - dis;
            this.setState({
                process: process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                    stage_Field: stage.
                        stage_Field.map(field => {
                            return Object.assign({}, { ...field }, { fieldValue: (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',')  :  (field.fieldDescription === 'Item Sub Total Including VAT'  && dis>0) ? dis : (field.fieldDescription === 'Tax Rate'  ) ? taxpercentage :  (field.fieldName === name) ? value : field.fieldValue })
                        })
                }))
            });  

        }

        if(el.fieldDescription === 'Name of Good or Service'){
            this.setState({ loading: true});
        axios.get(`/master/api/Employee/GetService?ServiceId=${value}`).then(response => {
            if (response.status === 200) {
                let index = 1;
                priceperunit = response.data.priceperunit;
                taxpercentage = response.data.taxpercentage;
                baseunit = response.data.baseunit;
                taxamount = (taxpercentage/100)*priceperunit;
            
                itemsubtotal = taxamount + priceperunit;
                this.setState({
                    process: process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                        stage_Field: stage.
                            stage_Field.map(field => {
                                return Object.assign({}, { ...field }, { fieldValue: (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',')  : (field.fieldDescription === 'Unit Price' && field.childRowNmbr== el.childRowNmbr) ? priceperunit : (field.fieldDescription === 'Quantity' && field.childRowNmbr== el.childRowNmbr ) ? 1 : (field.fieldDescription === 'Unit Of Measure' && field.childRowNmbr== el.childRowNmbr) ? baseunit : (field.fieldDescription === 'Taxable Amount' && field.childRowNmbr== el.childRowNmbr) ? priceperunit : (field.fieldDescription === 'Tax Amount'  && field.childRowNmbr== el.childRowNmbr) ? taxamount : (field.fieldDescription === 'Item Sub Total Including VAT'  && field.childRowNmbr== el.childRowNmbr) ? itemsubtotal : (field.fieldDescription === 'Tax Rate'   && field.childRowNmbr== el.childRowNmbr) ? taxpercentage :  (field.fieldName === name) ? value : field.fieldValue })
                            })
                    }))
                });         

                // currencyList = response.data.map(mod => {
                //     return { label: `${mod.text} - ${mod.requestNum}`, value: index++, id: mod.requestNum,}
                // });
            }
        })
        .catch(err => {
            this.growl.show({ severity: 'success', summary: null, detail: 'Service Deail API Failed, Please reload the page' });
        })
        this.setState({ loading: false});
    }



        // this.setState({
        //     process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue: type === 'checkbox' && field.fieldName === name ? checked : field.fieldName === name && el.fieldType === "3" ? value.join(',') : field.fieldName === name ? value : field.fieldValue })) }))
        // });
        this.setState({
            process: process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage.
                    stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',')  :  (field.fieldName === name) ? value : field.fieldValue })
                    })
            }))
        });
        this.setState({ payslipGenerated: false})


    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
        this.setState({requestattachments:attachmentData});
    }


    handleContainer = (field) => {
        this.setState({ loading: true });
        const { process, stageSequence } = this.state;
        let stages = process.filter((p, i) => i < parseInt(stageSequence) + 1);

        const { location } = this.props;
        
        let childRowNumber = Math.max(...stages[0].stage_Field.map(o => o.childRowNmbr)) ;   //field.childRowNmbr;
        let mystages = process.filter((p, i) => i < parseInt(stageSequence) + 1)
        let myfieldqty = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Quantity' && el.childRowNmbr == childRowNumber)
        let Quantity = myfieldqty[0].fieldValue ? myfieldqty[0].fieldValue : 0;
        let myfieldunitprice = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Unit Price' && el.childRowNmbr == childRowNumber)
        let Unitprice = myfieldunitprice[0].fieldValue ?  myfieldunitprice[0].fieldValue : 0;
        let myfieldTaxableAmount = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Taxable Amount' && el.childRowNmbr == childRowNumber)
        let TaxableAmount = myfieldTaxableAmount[0].fieldValue ? myfieldTaxableAmount[0].fieldValue : 0;
        let myfieldDiscount = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Discount' && el.childRowNmbr == childRowNumber)
        let Discount = myfieldDiscount[0].fieldValue ? myfieldDiscount[0].fieldValue : 0;        
        let myfieldTaxRate = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Tax Rate' && el.childRowNmbr == childRowNumber)
        let TaxRate = myfieldTaxRate[0].fieldValue ? myfieldTaxRate[0].fieldValue : 0;  
        let myfieldTaxAmount = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Tax Amount' && el.childRowNmbr == childRowNumber)
        let TaxAmount = myfieldTaxAmount[0].fieldValue ? myfieldTaxAmount[0].fieldValue : 0; 
        let myfieldItemSubTotal = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Item Sub Total Including VAT' && el.childRowNmbr == childRowNumber)
        let ItemSubTotal = myfieldItemSubTotal[0].fieldValue ? myfieldItemSubTotal[0].fieldValue : 0; 


        let myfieldTotalExVat = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Total Excluding VAT' )
        let TotalExVat = myfieldTotalExVat[0].fieldValue  ? Number(myfieldTotalExVat[0].fieldValue) + Number(ItemSubTotal) - Number(TaxAmount) : ItemSubTotal - TaxAmount;   
        
        let myfieldTotalVat = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Total VAT' )
        let TotalVat = myfieldTotalVat[0].fieldValue  ? Number(myfieldTotalVat[0].fieldValue) + Number(TaxAmount) : TaxAmount;    
        
        let myfieldTotalTaxAmtexVat = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Total Taxable Amount (Excluding VAT)' )
        let TotalTaxAmtexVat = myfieldTotalTaxAmtexVat[0].fieldValue  ? Number(myfieldTotalTaxAmtexVat[0].fieldValue) + Number(TaxableAmount):TaxableAmount ;   
        
        let myfieldTotalDiscount = mystages[0].stage_Field.filter(el => el.fieldDescription == 'Discount' && el.parentFieldId=='000')
        let TotalDiscount = myfieldTotalDiscount[0].fieldValue  ? Number(myfieldTotalDiscount[0].fieldValue) + Number(Discount):Discount ;    
        
        let myfieldTotalAmtDue= mystages[0].stage_Field.filter(el => el.fieldDescription == 'Total Amount Due' )
        let TotalAmtDue = myfieldTotalAmtDue[0].fieldValue  ? Number(myfieldTotalAmtDue[0].fieldValue) + Number(ItemSubTotal) : ItemSubTotal;  


        let error = 0;
        const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
            if (stageIndex === 0) {
                // this.setState({
                //     process: process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                //         stage_Field: stage.
                //             stage_Field.map(field => {
                //                 return Object.assign({}, { ...field }, { fieldValue: 1000});//(field.fieldDescription == 'Total Excluding VAT'  ) ? TotalExVat : (field.fieldDescription === 'Total Taxable Amount (Excluding VAT)' ) ? TotalTaxAmtexVat : (field.fieldDescription === 'Total VAT' ) ? TotalVat : (field.fieldDescription === 'Discount' && field.parentFieldId=='000' ) ? TotalDiscount  : 1000 })
                //             })
                //     }))
                // });



                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName  ), 'childRowNmbr')) || [];
                const fields = containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1] || [];
                if (fields && fields.length > 0 ) {
                    let count = stageField.length + 1;
                    let sequence = stageField.length + 1;
                    const newFields = fields.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: field.fieldName, childRowNmbr: Object.keys(containerGroup).length.toString(), fieldValue: (el.fieldType == 1) ? ((el.fieldDescription == 'Total Taxable Amount (Excluding VAT)') ? TotalTaxAmtexVat : "") : null }));
                        return a;
                    }, []);
                    return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
                } else if (location && location.state && location.state.stagesequence === stageIndex) {
                    error = 1;
                    return stage;
                }
                 else {
                    return stage;
                }
            } else {
                return stage;
            }
        });

        const InitialValues2 = InitialValues.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {

                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        let count = stageField.length + 1;
                        let sequence = stageField.length + 1;
                        a.push(Object.assign({}, { ...el }, {  fieldValue: (el.fieldDescription == 'Total Excluding VAT')   ? TotalExVat : (el.fieldDescription === 'Total Taxable Amount (Excluding VAT)') ? TotalTaxAmtexVat : (el.fieldDescription === 'Total VAT')  ? TotalVat : (el.fieldDescription === 'Discount' && field.parentFieldId=='000')  ? TotalDiscount  : (el.fieldDescription === 'Total Amount Due')  ? TotalAmtDue : el.fieldValue }));

                        return a;
                    }, [])
                })  
            });



        setTimeout(() => {
            this.setState({ loading: false, process: InitialValues2 });
            if (error)
                this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }, 3000);
    }

    rowExpansionTemplate = (data) => {

        let currency = currencyList.find(el => el.value == data.Original_Currency);
        let currencyId = currency && currency.id || '';
        let currencyLabel = currency && currency.label || '';

        return (
            <div className="p-grid p-fluid" style={{ padding: '2em 1em 1em 1em' }}>
                <div className="p-col-12 p-md-12">
                    <div className="p-grid">

                        <div className="p-md-3">Name of Goods or Service: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Name_of_Good_or_Service}</div>

                        <div className="p-md-3">Unit Price </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Unit_Price}</div>

                        <div className="p-md-3">Quantity </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Quantity}</div>

                        <div className="p-md-3">Unit Of Measure </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Unit_Of_Measure}</div>

                        <div className="p-md-3">Taxable Amount: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Taxable_Amount}</div>

                        <div className="p-md-3">Tax Rate </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Tax_Rate}</div>

                        <div className="p-md-3">Tax Amount </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Tax_Amount}</div>

                        <div className="p-md-3">Discount </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Discount}</div>

                        <div className="p-md-3">Item_Sub_Total_Including_VAT: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Item_Sub_Total_Including_VAT}</div>


                    </div>
                </div>
            </div>
        );
    }

    initialize = (process, type, field) => {
        const { tableLists, location = {}} = this.props;
        const { stageSequence } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;         
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith


        let count = 1;
        let sequence = 1;
        if (type === 'progress' || type === 'add' || type === 'edit') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'add' && el.fieldType === '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                            const lastItem = a[a.length - 1];
                            fields.map((subField) => {
                                a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                            })
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                        })
                                    }
                                })
                            }
                        }
                        return a;
                    }, [])
                })
            });

            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
        } else {

            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;

        let RequestAttributes = [];
        let Comment = '';
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8") ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            })
        });



        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Sales Invoice',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: RECINVOICE_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'Service';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'Service';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'Service';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
            }


            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            axios.post(url, JSON.stringify(datas))
                .then(response => {

                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
                                    })
                                }
                                if(submitType === 'submit'){
                                    this.setState({dialogBoxText: "Select Supervisor"})
                                }
                                if(submitType === 'return'){
                                    this.setState({dialogBoxText: "Return To", popupType:'return'})
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'Invoice submitted successfully' });
                                this.sendToZatca(response.data);   // testing: every submit. See sendToZatca to move it to the final stage.
                                //this.props.history.push('/dashboardService');
                                        //code to make work permit email upload work
                                       if (this.state.stageSequence != 0) {
                                        this.generateInvoice('upload')
                                        .then((generatedPdf) => {
                                            this.uploadGeneratedInvoice(generatedPdf)
                                            .then(response => {
                                                this.setState({ loading: false });
                                                if(response.status == 200){
                                                this.growl.show({ severity: 'success', life:3000, summary: null, detail: 'Invoice submitted successfully' });
                                                // TESTING (ZATCA): stay on the page so the clearance result is visible.
                                                // setTimeout(() => {
                                                //     this.props.history.push('/dashboardService')
                                                // }, 2000);
                                                }
                                            })
                                            .catch(err => {//catch to the submit request api
                                                this.setState({ loading: false });
                                                this.growl.show({ severity: 'success', summary: null, life:3000, detail: 'Invoice submitted successfully' });
                                                this.growl.show({ severity: 'error', summary: null, life:3000, detail: 'Email Attachment Failed, Please contact administrator' });
                                                // TESTING (ZATCA): stay on the page so the clearance result is visible.
                                                // setTimeout(() => {
                                                //     this.props.history.push('/dashboardService')
                                                // }, 1800);
                                            })
                                        }).catch((err) => {// catch to the workpermit data download api
                                            this.setState({ loading: false });
                                            this.growl.show({ severity: 'success', summary: null, life:3000, detail: 'Invoice submitted successfully' });
                                            this.growl.show({ severity: 'error', summary: null, life:3000, detail: 'Invoice PDF generation failed. Please contact administrator.' });
                                            // TESTING (ZATCA): stay on the page so the clearance result is visible.
                                            // setTimeout(() => {
                                            //     this.props.history.push('/dashboardService')
                                            // }, 1800);
                                        })

                                    }
                                    else
                                    {

                                        this.setState({ loading: false });
                                        if(response.status == 200){
                                        this.growl.show({ severity: 'success', life:3000, summary: null, detail: 'Invoice submitted successfully' });
                                        // TESTING (ZATCA): stay on the page so the clearance result is visible.
                                        // setTimeout(() => {
                                        //     this.props.history.push('/dashboardService')
                                        // }, 2000);
                                        }
                                    }




                                
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Service request saved successfully' });
                        // Save returns the request number (SIV-…), so clear from here too —
                        // this is the branch a plain Save takes, not the submit branch above.
                        this.sendToZatca(response.data);
                        // TESTING (ZATCA): stay on the page so the clearance result is visible.
                        // this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                })

        }

    }
    /**
     * ZATCA Phase 2: has ZatcaTest sign this invoice and clear it with ZATCA.
     *
     * Deliberately fire-and-forget. The invoice is already saved in the RMS by the
     * time this runs, so a ZATCA failure must not undo the submit or block the
     * redirect — it reports itself and the invoice can be cleared again later.
     *
     * WHEN THIS RUNS — every successful Save and every successful Submit, which is
     * what we want while testing. Before production it moves to the final approval
     * stage, so only an approved invoice is cleared: keep the call in the submit
     * branch only, wrapped in `if (this.state.stageSequence != 0) { ... }` — the
     * same condition the PDF upload uses — and drop the one in the save branch.
     * Clearance spends a counter value and is not reversible, so an invoice cleared
     * at draft stage and then rejected by an approver leaves a cleared document with
     * nothing behind it.
     *
     * TEMPORARY: the buyer is ZATCA's sample buyer. Replace it with the selected
     * customer once the RMS customer API exists — see
     * src/Containers/Masters/Zatca/CUSTOMER-API-REQUEST.md.
     */
    sendToZatca = (responseData) => {
        const { metaData } = this.props;
        const lines = buildZatcaLines(this.state.process, metaData);

        // Save then Submit would otherwise clear the same invoice twice, and a
        // cleared invoice cannot be taken back — each one is a real tax document
        // with its own counter value. Reload the page to clear a new one.
        if (this.state.zatcaInvoice) {
            this.growl.show({ severity: 'info', life: 6000, summary: null, detail: 'ZATCA: already cleared as ' + this.state.zatcaInvoice.invoiceNumber + '.' });
            return;
        }

        if (lines.length === 0) {
            this.growl.show({ severity: 'warn', life: 6000, summary: null, detail: 'ZATCA: no invoice lines found, nothing was sent for clearance.' });
            return;
        }

        this.setState({ zatcaSending: true, zatcaError: false });

        issueStandardInvoice({
            orderReference: readOrderReference(responseData),
            supplyDate: readSupplyDate(this.state.process),
            lines: lines,
            buyer: SAMPLE_BUYER
        })
            .then(response => {
                const invoice = response.data || {};
                this.setState({ zatcaSending: false, zatcaInvoice: invoice });
                this.growl.show({ severity: 'success', life: 6000, summary: null, detail: 'ZATCA cleared invoice ' + invoice.invoiceNumber + ' (total ' + invoice.totalAmount + ').' });
            })
            .catch(err => {
                const detail = describeZatcaError(err);
                this.setState({ zatcaSending: false, zatcaError: detail });
                this.growl.show({ severity: 'error', life: 10000, summary: null, detail: 'ZATCA: ' + detail });
            });
    }

    uploadGeneratedInvoice = (generatedPdf) => {
        return new Promise((resolve, reject) => {
            axiosRetry(axios, { 
                retries: 8,
                retryCondition: (error) => {
                    // if retry condition is not specified, by default idempotent requests are retried
                    return error;
                  },
            });//For retrying 8 times
            axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            .then((response => {
                resolve(response);
            })).catch((err) => {
                reject(err);
            })
        })
    }

    componentDidMount() {
        const { getContainerData, getKeywordValues, getMasterKeywordList, location = {}, loggedUserDetail } = this.props;
        const type = this.props.match.params.type;
        // this.effectiveDateHandler()
        getContainerData(RECINVOICE_ID);//Get Container Data
        getKeywordValues('Employee');//Get Employee Dropdown list
        getMasterKeywordList('Employee');//Get Employee        
        //getKeywordValues('Service Type');//Get Employee Dropdown list
        getKeywordValues('ServiceType');//Get Destination City Dropdown list
        getMasterKeywordList('ServiceType');
        getKeywordValues('Customer');
        getKeywordValues('Service');
        getKeywordValues('UOM');
        getKeywordValues('Currency');
        getMasterKeywordList('Vendor');
        getMasterKeywordList('Service');
        getMasterKeywordList('UOM');
        getMasterKeywordList('Currency');                 

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({requestattachments});

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300);

    }

    handleMethods(type) {
        this.setState({ popupType: type });
        const { keywordValuesList } = this.props;
        this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesList })
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, keywordValuesList: [] })
    }

    actionTemplate = (rowData) => {
        return <div>
            <Button type="button" icon="pi pi-pencil" className="p-button-info" onClick={() => this.setState({ editing: rowData })} />
        </div>;
    }

    currencyNameRender(rowData) {
        let currencyId = +rowData.Original_Currency;
        let currency = currencyList.filter(currencies => currencies.value == currencyId);
        return (currency.length > 0 && currency[0].label) || '';
    }

    generateInvoice = (type) =>{
        return new Promise((resolve ,reject)=>{ //Implementing promise for this function to be used in the "saveRequest" function for uploading pdf before saving request
        this.setState({loading:true});
        const { process } = this.state;
        //let InvoiceNumber = this.state.Invoicenumber ;
        let InvoiceId;
        // let si=0;
        // process.map((stage, si) => {
        //     stage.stage_Field.map(el => {
        //         if (el.fieldDescription === 'Invoice Number' ) {
        //             InvoiceNumber = el.fieldValue;
        //         }
        //     })
        // });

        if (this.state.requestId) {
            InvoiceId = this.state.requestId
        }

       // axiosRetry(axios, { retries: 3 });//For retrying 8 times
        axios.get('/master/api/GetInvoiceforprint?InvoiceId=' + InvoiceId)
        .then((response => {
            //assingning variable from response(start)
            let data = response.data;
            let Customer = (data.customer) ? data.customer : [];            
            let Company = (data.company ) ? data.company : [];
            let InvoiceHDR = ( data.waInvoice ) ? data.waInvoice : [];
            let InvoiceLine = (data.itInvoiceLine && data.itInvoiceLine.length > 0) ? data.itInvoiceLine : [];
            // let workpermitStatusRei = (data.workpermitStatusRei && data.workpermitStatusRei.length > 0) ? data.workpermitStatusRei : [];
            // let workpermitStatusSur = (data.workpermitStatusSur && data.workpermitStatusSur.length > 0) ? data.workpermitStatusSur : [];

            let precautionsTableHeader = [];
            let precautionsTableBody = [];
            let precautionsTableData = [];

            let invoiceLineTableHeader = [];
            let invoiceLineTableBody = [];
            let invoiceLineTableData = [];            
            
            //finding if there are multiple wcds in the workpermit
            let Invoiceitem= 'none';
            let firstPageWcditem = [];

                if(InvoiceLine.length > 0){
                    Invoiceitem = 'multiple';
                    firstPageWcditem = InvoiceLine[0];
                } else {
                    Invoiceitem = 'single';
                    firstPageWcditem = InvoiceLine[0];
                }
        

            let Invoicenumber = InvoiceHDR.invoicenumber || 'N/A';       
                this.setState({Invoicenumber:Invoicenumber});
            let Invoicedate = InvoiceHDR.docdatet || 'N/A';
            let Duedate = InvoiceHDR.duedate || 'N/A';            
            let Currencycode = InvoiceHDR.currencycode || 'N/A';
            let Ponumber = InvoiceHDR.ponumber || 'N/A';            
            let InvoiceNetTotal = InvoiceHDR.netwr || 'N/A';
            let Totalamtexclvat = InvoiceHDR.totalamtexclvat || 'N/A';            
            let Discount = InvoiceHDR.discount || 'N/A';
            let Totaltaxableamtexclvat = InvoiceHDR.totaltaxableamtexclvat || 'N/A';            
            let Totalvat = InvoiceHDR.totalvat || 'N/A';

            let NameAr = Company.NameAr || 'N/A';
            let BuildingNo =  Company.buildingNo || 'N/A';
            let Street = Company.street || 'N/A';
            let District =  Company.District || 'N/A';            
            let City = Company.city || 'N/A';
            let CountryCode =  Company.countryCode || 'N/A';
            let CountryName = Company.countryName || 'N/A';
            let PostalCode =  Company.postalCode || 'N/A';    
            let Mobile = Company.mobile || 'N/A';
            let Email =  Company.email || 'N/A';
            let AdditionalNo = Company.additionalNo || 'N/A';
            let VatNo =  Company.vatNo || 'N/A';            
            let OtherNo = Company.otherNo || 'N/A';
            let BankName =  Company.bankName || 'N/A';
            let BankAccountName = Company.bankAccountName || 'N/A';
            let BankAccountNo =  Company.bankAccountNo || 'N/A';     
            let BankBranch =  Company.bankBranch || 'N/A';
            let Ibanno = Company.ibanno || 'N/A';
            let Swiftcode =  Company.swiftcode || 'N/A';            
            let BankCity = Company.bankCity || 'N/A';
            let BankCountry =  Company.bankCountry || 'N/A';
            let BankAddress = Company.bankAddress || 'N/A';
            let Customerno =  Customer.Customerno || 'N/A';              
            let Address =  Customer.Address || 'N/A';  
            let Name =  Customer.Name || 'N/A';              
            let Creditlimit =  Customer.Creditlimit || 'N/A';  
            let Contactrep =  Customer.Contactrep || 'N/A';              
            let Emailid =  Customer.emailid || 'N/A';              
            let Country =  Customer.country || 'N/A'; 
            let Createdby =  Customer.Createdby || 'N/A';              
            let Createddate =  Customer.Createddate || 'N/A';  
            let Glaccount =  Customer.glaccount || 'N/A';              
            let Companyid =  Customer.Companyid || 'N/A';  
            // let NameAr =  Customer.NameAr || 'N/A';              
            // let BuildingNo =  Customer.BuildingNo || 'N/A';  
            // let Street =  Customer.Street || 'N/A';              
            // let District =  Customer.District || 'N/A';   
            // let City =  Customer.City || 'N/A';              
            // let CountryCode =  Customer.CountryCode || 'N/A';  
            // let CountryName =  Customer.CountryName || 'N/A';              
            // let PostalCode =  Customer.PostalCode || 'N/A';  
            // let AdditionalNo =  Customer.AdditionalNo || 'N/A';              
            // let VatNo =  Customer.VatNo || 'N/A';  
            // let OtherNo =  Customer.OtherNo || 'N/A';              
            // let BankName =  Customer.BankName || 'N/A';  
            // let BankAccountName =  Customer.BankAccountName || 'N/A';              
            // let BankAccountNo =  Customer.BankAccountNo || 'N/A';  
            // let BankBranch =  Customer.BankBranch || 'N/A';              
            // let Ibanno =  Customer.Ibanno || 'N/A';                                     
            // let Swiftcode =  Customer.Swiftcode || 'N/A';              
            // let BankCity =  Customer.BankCity || 'N/A';  
            // let BankCountry =  Customer.BankCountry || 'N/A';              
            // let BankAddress =  Customer.BankAddress || 'N/A';  



            // let isPermitAccess = (rWorkPermit.wapiuse == "ACC") ? true : false
            // let safetyDocumentNumber = rWorkPermit.sappermitNo;
            // let keySafeNumber = (isPermitAccess) ? `AZN`: `Key Safe Key Number: \n${rWorkPermit.lockboxKey || 'N/A'}`;// if heading is permit access, this is AZN 
            // let dpSheetNumber = rWorkPermit.wcdnr || 'N/A';
            // let riskAssesmentNumber = rWorkPermit.riskassessmentno || 'N/A';
            // let workOrderNumber = rWorkPermit.workOrderNo || 'N/A';
            // let workBriefInstructions = rWorkPermit.permitDescription || 'N/A';
            // let kksNumber = rWorkPermit.tplnr || 'N/A';
            // let kksDescripton = rWorkPermit.tptxt || 'N/A';

            // let approverName = rWorkPermit.approver || '';
            // let approveTime = (rWorkPermit.approvetime.length > 0) ?  rWorkPermit.approvetime.slice(0, -1) : ''; //to remove the extra ":" coming from api
            // let approvedDate = (moment(rWorkPermit.approvedate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.approvedate).format("DD/MM/YYYY") ;

            // let issuedByName= rWorkPermit.issuedbyname || '';
            // let issuedDate= (moment(rWorkPermit.issueddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.issueddate).format("DD/MM/YYYY") ;
            // let issuedTime= (moment(rWorkPermit.issueddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.issueddate).format("h:mm:ss A") ;

            // let acceptedByName= rWorkPermit.acceptedbyname || '';
            // let acceptedDate= (moment(rWorkPermit.accepedate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.accepedate).format("DD/MM/YYYY") ;
            // let acceptedTime= (moment(rWorkPermit.accepedate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.accepedate).format("h:mm:ss A") ; 
            // let acceptedByDepartment= rWorkPermit.acceptedbydepartment || '';

            // let clearedComment = rWorkPermit.clearedcomment || '';
            // let clearedByName = rWorkPermit.clearedbyname || '';
            // let clearedTime = (moment(rWorkPermit.cleareddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cleareddate).format("h:mm:ss A") ;
            // let clearedDate = (moment(rWorkPermit.cleareddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cleareddate).format("DD/MM/YYYY") ;
            
            

            // let cancelledByName = rWorkPermit.cancelledbyname || '';
            // let cancelledTime = (moment(rWorkPermit.cancelleddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cancelleddate).format("h:mm:ss A");
            // let cancelledDate = (moment(rWorkPermit.cancelleddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cancelleddate).format("DD/MM/YYYY");

            //assingning variable from response(end)

            //first page table calculations started
            let firstPageWcdTableHght = (InvoiceLine.length > 0) ? 40 : 10;

            //first page table calculations ended


            //precaution table calculations started

            invoiceLineTableHeader = [
                    [{
                    content: 'Nature Of Goods or Services',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Unit Price',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Quantity',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Taxable Amount',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Discount',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Tax Rate',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Tax Amount',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Item SubTotal (Including VAT)',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},]
                ];
                invoiceLineTableBody = InvoiceLine.map((el, index) => {
                    return[
                        //    {
                        //    content: index + 1,
                        //    styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        //    }},
                            {
                            content: el.serviceName || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.unitrate || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.qty || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.taxableAmount || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.discount || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.taxpercentage || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.taxvalue || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.total || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                        ]
                    
                })
                ////invoiceLineTableBody.splice(0, 1);
                invoiceLineTableData =invoiceLineTableHeader.concat(invoiceLineTableBody);
           



            //precaution table calculations ended


            //safety catalog calculations start

            //safety catalog calculations end

            // pdf generation starts
            var doc = new jsPDF('p', 'mm', 'a4', 3);//jsPDF(orientation, unit, format)
            let text = '';
            doc.setFontStyle('normal');
            doc.setFont("Courier");  
            doc.setFontSize(10);
        
            doc.autoTable({
                theme: 'grid',
                didDrawCell: function(data) {
                    if (data.column.index === 0 && data.cell.section === 'body') {
                        var dim = data.cell.height - data.cell.padding('vertical');
                       doc.addImage(baseLogoGlencoImg, 'PNG', 0, 1, 200, 45);
                    }
                  },
                startY: 7,
                margin: {
                    left: 1.5
                },
                columnStyles: { 0: { cellWidth: 45, }},
                lineWidth: 18,
                body: [
                        [
                            {
                            content: "",
                            rowSpan: 2,
                            styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},                                                                                   
                        ], 
                        // [
                        //     {
                        //     content: "SELLER",
                        //     styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        //     }},
                        //     {
                        //     content: "BUYER",
                        //     styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
                        //     }},
                        // ],
                        // [
                        //     {
                        //     content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        //     styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
                        //     }},
                        //     {
                        //     content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        //     styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        //     }},

                        // ],
                        
                ]
                
            });
            let previousTableEnding = doc.lastAutoTable.finalY;
           
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 40,
                     margin: {
                    left: 5,
                    right: 35
                },
                tableWidth: 200,
                columnStyles: { 0: { cellWidth: 55, }},
                lineWidth: 35,
                body: [
                        [
                            {
                            content: "Invoice Number: " + Invoicenumber,
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
                            {
                                content: "Invoice Date: " + moment(Invoicedate).format('DD/MM/YYYY'),
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }}, 
                            {
                                content: "Due Date: " + moment(Duedate).format('DD/MM/YYYY'),
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
                            {
                                content: "Currency: " + Currencycode,
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},                                                                                   
                        ], 
                        // [
                        //     {
                        //     content: "SELLER",
                        //     styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        //     }},
                        //     {
                        //     content: "BUYER",
                        //     styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
                        //     }},
                        // ],
                        // [
                        //     {
                        //     content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        //     styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
                        //     }},
                        //     {
                        //     content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        //     styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        //     }},

                        // ],
                        
                ]
                
            });            

             previousTableEnding = doc.lastAutoTable.finalY;
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 7,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                body: [
                    [
                        {
                        content: "SELLER",
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},
                        {
                        content: "BUYER",
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
                        }},
                    ],
                    [
                        {
                        content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        styles: { halign: 'left',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
                        }},
                        {
                        content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        styles: { halign: 'left',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},

                    ],

                ]

            });    
            previousTableEnding = doc.lastAutoTable.finalY;

            // work permit generation ending

            //safety catalog table generation started
            let pageNumber1 = doc.internal.getCurrentPageInfo().pageNumber;// test to print safety catalog on next page to avoid overlapping 

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 7,
                styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [231, 215, 252]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                body: invoiceLineTableData,

            });


            previousTableEnding = doc.lastAutoTable.finalY;
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 7,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                body: [
                    [
                        {
                        content: "Total Amounts",
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},
                        {
                        content: "Total Amounts In Arabic",
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
                        }},
                    ],
                    [
                        {
                        content: "Total(Excluding Vat): " + Totalamtexclvat + "\n" + "Discount: " + Discount + "\n" + "Total Taxable Amount(Excluding Vat): " + Totaltaxableamtexclvat + "\n" + "Total Vat: " + Totalvat + "\n" + "Total Amount Due: " + InvoiceNetTotal,
                        styles: { halign: 'left',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
                        }},
                        {
                            content: "Total(Excluding Vat): " + Totalamtexclvat + "\n" + "Discount: " + Discount + "\n" + "Total Taxable Amount(Excluding Vat): " + Totaltaxableamtexclvat + "\n" + "Total Vat: " + Totalvat + "\n" + "Total Amount Due: " + InvoiceNetTotal,
                            styles: { halign: 'left',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},

                    ],

                ]

            });    

            previousTableEnding = doc.lastAutoTable.finalY;
            doc.autoTable({
                theme: 'grid',
                styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [231, 215, 252]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                startY: 270,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                body: [
                    [
                        {
                        content: "This is system Generated Invoice. No Signature Required",
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},
                        
                    ],
                    

                ]

            });             

            //safety catalog table generation ended

            //transfer record creation
    
            // doc.autoTable({
            //     theme: 'grid',
            //     didDrawCell: function(data) {
            //         if (data.column.index === 0 && data.cell.section === 'body') {
            //             var dim = data.cell.height - data.cell.padding('vertical');
            //            doc.addImage(baseLogoImg, 'JPEG', 3, 7, 35, 15);
            //         }
            //       },
            //     startY: 5,
            //     margin: {
            //         left: 1.5
            //     },
            //     columnStyles: { 0: { cellWidth: 45, }},
            //     lineWidth: 15,
            //     body: [
            //             [
            //                 {
            //                 content: "",
            //                 rowSpan: 2,
            //                 styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                 content: "Invoice Number: " + Invoicenumber,
            //                 styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                     content: "Invoice Date: " + Invoicedate,
            //                     styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }}, 
            //                 {
            //                     content: "Due Date: " + Duedate,
            //                     styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                     content: "Currency: " + Currency,
            //                     styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},                                                                                   
            //             ], 
            //             [
            //                 {
            //                 content: "SELLER",
            //                 styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                 content: "BUYER",
            //                 styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
            //                 }},
            //             ],
            //             [
            //                 {
            //                 content: "Name: " + dpSheetNumber + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
            //                 styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
            //                 }},
            //                 {
            //                 content: "Name: " + dpSheetNumber + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
            //                 styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},

            //             ],
                        
            //     ]
                
            // });




            if(type === 'print'){
                doc.autoPrint()
                window.open(doc.output('bloburl'), Invoicenumber)
                this.setState({ loading: false });
                resolve("Promise Resolved");
            } else if(type === 'view'){
                window.open(doc.output('bloburl'), Invoicenumber)
                this.setState({ loading: false });
                resolve("Promise Resolved");
            } else if (type === 'download'){
                doc.save(Invoicenumber);
                this.setState({ loading: false });
                resolve("Promise Resolved");
            } else if(type === 'upload'){ 
                let pdf = btoa(doc.output());
                let FileName = Invoicenumber;
                let Folder = 'SalesInvoice';
                let Attachment = pdf;
                let MailData = {
                    FileName,
                    Folder,
                    Attachment
                }
    
                let dd = JSON.stringify(MailData);
                let  generatedPdf = {Key : dd};
                resolve(JSON.stringify(generatedPdf));                
            }
        })).catch((err) => {
            if(type === 'upload'){ // to prevent multiple error messages when this method is used in "saveRequest" method
                this.setState({ loading: false })
                reject("Promise Failed");
            } else {
                this.setState({ loading: false })
                this.growl.show({ severity: 'error', summary: null, detail: 'Cannot Download Invoice. Please try again.' });
                reject("Promise Failed");
            }
        })
    })
    }    

    render() {
        const { tableLists, location = {}, metaData = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence, editing } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;  
        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );


        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Invoice
                            <Link to={'/RecInvoice'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>
                

                
                {!this.props.loading && !this.state.loading && process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerFields = (containerGroup && Object.keys(containerGroup).length > 0 && editing && editing.parentFieldId === field.fieldName && containerGroup[editing.childRowNmbr]) || (containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1]) || [];
                                    const containerTable = containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).filter((g, i) => i != Object.keys(containerGroup).length - 1).reduce((tableRow, row) => {
                                        const rowFields = containerGroup[row].reduce((r, c) => {
                                            const DropdownValues = metaData[c.fieldDescription] && c.fieldValue && metaData[c.fieldDescription].find(_ => _.value === c.fieldValue) || false;
                                            return Object.assign({}, { ...r }, { [c.fieldDescription.replaceAll(' ', '_')]: (DropdownValues && DropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue, childRowNmbr: c.childRowNmbr, parentFieldId: c.parentFieldId })
                                        }, {});
                                        tableRow.push(rowFields);
                                        return tableRow;
                                    }, []) || [];
                                   
                                    return field.parentFieldId === "000" ? <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldType != "9" ? <Inputs
                                            field={field}
                                            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
                                            process={process}
                                            onInputChange={(e) => this.handleChange(e, field)}
                                            {...this.props}
                                            {...this.state} /> :
                                            field.fieldType === '9' ?
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? true : this.state[field.fieldName]} onToggle={(e) => this.setState({[field.fieldName]: e.value})} style={{border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)'}}>
                                                    <div className="p-grid">
                                                        {containerFields.map((subField, subIndex) => <div key={subIndex} className={"p-col-12 p-md-6 p-lg-4"}><Inputs
                                                            field={subField}
                                                            value={subField.fieldType === '3' && subField.fieldValue ? subField.fieldValue.split(",") : subField.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, subField)}
                                                            {...this.props}
                                                            {...this.state} /></div>)}
                                                        <div className="p-col-12 p-md-6 p-lg-4">
                                                            {editing && editing.parentFieldId === field.fieldName ? <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-pencil" onClick={() => this.setState({ editing: false })} label="Update" style={{ marginRight: '10px' }} />
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" onClick={() => this.setState({ editing: false })} label="Cancel" />
                                                            </div> : <div className="mt2" style={{ padding: '8px' }}>
                                                                    <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add" />
                                                                </div>}
                                                        </div>
                                                        <div className="p-col-12">
                                                            <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                            expandableRowGroups={false} expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                                                            rowExpansionTemplate={this.rowExpansionTemplate} 
                                                            dataKey="childRowNmbr" rows={10} value={containerTable}>
                                                            <Column expander={true} style={{ width: '3em' }} />
                                                                {containerFields.map((columnField, columnIndex) =>
                                                                    (pageType == 'edit' & columnField.fieldDescription == 'Original Currency') ? <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} body={this.currencyNameRender} /> : <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} /> 
                                                                    )}
                                                                {
                                                                    ((pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null)) ? null : <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                }
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </Fieldset> : null}
                                    </div> : null

                                })}


                                {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'SalesInvoice'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        <Button disabled={(pageType === 'edit' && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? false : true} label="Download" onClick={() => this.generateInvoice('download')} className="p-button-success ml1" />
                                        <Button disabled={(pageType === 'edit' && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? false : true} label="Print" onClick={() => this.generateInvoice('print')} className="p-button-success ml1" />

                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/RecInvoice'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit'  === 0 && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? false : true} label="Download" onClick={() => this.generateInvoice('download')} className="p-button-success ml1" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />
                                        <Button disabled={(pageType === 'edit' && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? false : true} label="Print" onClick={() => this.generateInvoice('print')} className="p-button-success ml1" />
                                        <Link to={'/RecInvoice'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }
}

const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    let relevantOptions = [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) {
                a.push(el);
            }
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }
    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData,
        Employee,
        EmployeeList: relevantOptions,
        currencyList: currencyList && currencyList || [],
        keywordValuesList,
        metaData: Object.assign({}, {
            "Requested For": relevantOptions,
            "Service Type": state.keyword.ServiceType,
            "Currency":state.keyword.Currency,
            "Customer":state.keyword.Vendor,
            "Unit Of Measure":state.keyword.UOM,
            "Name of Good or Service":state.keyword.Service
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddInvoice);